export const TRAININGS = {
  LIST: 'TRAININGS_LIST',
  LIST_DONE: 'TRAININGS_LIST_DONE',
  LIST_FAILED: 'TRAININGS_LIST_FAILED',
};

export const loadTrainings = params => ({ type: TRAININGS.LIST, params });



// WEBPACK FOOTER //
// ./src/actions/trainings.js